import {Module} from "vuex";

const confirmBeforeLeaving: Module<any, any> = {
  state: {
    needToBlock: false,
  },
  getters: {},
  mutations: {
    modifyBlockingState(state, need: boolean) {
      state.needToBlock = need;
    },
  },
  actions: {},
};

export default confirmBeforeLeaving;
